/**
 * ! (☞ﾟヮﾟ)☞ Don't forget to update the readme when changing this file.
 */

// Feature flags that apply to all partners.
const staticFeatureFlags = {
  IS_CA_EXPANSION_ENABLED: 'sc_194788',
  IS_BRAZE_ENABLED: `is_braze_enabled`,
  IS_CREDIT_KARMA_OFFER_ENABLED: `m107416`,
  IS_PARTNER_PHONE_NUMBER_ENABLED: `isTenantPhoneNumberEnabled`,
  IS_QUOTE_ASSIST_ENABLED: `isQuoteAssistEnabled`,
  IS_TOYOTA_RENTERS_ACCOUNT_CTA_HIDDEN: 'sc_209226',
  IS_TOYOTA_UPFRONT_PHONE_COLLECTION_ENABLED: 'sc_217215',
  IS_CO_EXPANSION_ENABLED: 'T1_CO',
  IS_CO_TAI_EXPANSION_ENABLED: 'T1_CO_TAI',
  IS_GA_TAI_EXPANSION_ENABLED: 'T1_GA_TAI',
  IS_GA_EXPANSION_ENABLED: 'T1_GA',
  IS_OR_EXPANSION_ENABLED: 'T1_OR',
  IS_OR_TAI_EXPANSION_ENABLED: 'T1_OR_TAI',
} as const;

// Feature flags that need to be toggled indepdendently from partner to partner.
function generateFlagsForPartner(partner: 'CK' | 'Toggle' | 'Toyota') {
  const uppercased = partner.toUpperCase() as Uppercase<typeof partner>;

  // Key: the enum key we use within this repo.
  // Value: the value set in our feature flag API.
  const flags = {
    // Flags that turn individual features on or off.
    features: [
      {
        key: `IS_${uppercased}_ACCOUNT_MANAGEMENT_ENABLED`,
        value: `is${partner}AccountManagementEnabled`,
      },
      {
        key: `IS_${uppercased}_ACCOUNT_MANAGEMENT_ENABLED`,
        value: `is${partner}AccountManagementEnabled`,
      },
      {
        key: `IS_${uppercased}_ACCOUNT_MANAGEMENT_ENABLED`,
        value: `is${partner}AccountManagementEnabled`,
      },
      {
        key: `IS_${uppercased}_AUTO_PURCHASE_FLOW_ENABLED`,
        value: `is${partner}AutoPurchaseFlowEnabled`,
      },
      {
        key: `IS_${uppercased}_AUTO_QUOTE_LINK_EXCHANGE_ENABLED`,
        value: `is${partner}AutoQuoteLinkExchangeEnabled`,
      },
      {
        key: `IS_${uppercased}_AUTO_QUOTE_LINK_EXCHANGE_ENABLED`,
        value: `is${partner}AutoQuoteLinkExchangeEnabled`,
      },
      {
        key: `IS_${uppercased}_DIRECT_TO_AUTO_QUOTE_ENABLED`,
        value: `is${partner}DirectToAutoQuoteEnabled`,
      },
      {
        key: `IS_${uppercased}_LOGO_REDIRECT_IN_AUTO_PURCHASE_FLOW_ENABLED`,
        value: `is${partner}LogoRedirectInAutoPurchaseFlowEnabled`,
      },
      {
        key: `IS_${uppercased}_PRIVACY_AND_TERMS_ENABLED`,
        value: `is${partner}PrivacyAndTermsEnabled`,
      },
      {
        key: `IS_${uppercased}_SELF_SERVICE_ENABLED`,
        value: `is${partner}SelfServiceEnabled`,
      },
      {
        key: `IS_${uppercased}_RENTERS_QUOTE_CREATION_ENABLED`,
        value: `is${partner}RentersQuoteCreationEnabled`,
      },
      {
        key: `IS_${uppercased}_QUOTE_ASSIST_ENABLED`,
        value: `is${partner}QuoteAssistEnabled`,
      },
      {
        key: `IS_${uppercased}_THEME_DISABLED`,
        value: `is_${partner}_theme_disabled`,
      },
      {
        key: `IS_${uppercased}_QA_START_SCREEN_ENABLED`,
        value: `${partner}_qa_start_screen`,
      },
    ] as const,
    // Flags that enable or disable whole regions.
    stateExpansions: [
      {
        key: `IS_${uppercased}_TX_EXPANSION_ENABLED`,
        value: `is${partner}TXExpansionEnabled`,
      },
    ] as const,
  };

  type TKeys = typeof flags[keyof typeof flags][number]['key'];
  type TValues = typeof flags[keyof typeof flags][number]['value'];
  type TFlags = Record<TKeys, TValues>;

  return [...flags.features, ...flags.stateExpansions].reduce(
    (acc, curr) => ({ ...acc, [curr.key]: curr.value }),
    {} as TFlags
  );
}

export const featureFlag = {
  ...staticFeatureFlags,
  ...generateFlagsForPartner('CK'),
  ...generateFlagsForPartner('Toggle'),
  ...generateFlagsForPartner('Toyota'),
};
